// Product Service - Fetches catalog data from the backend API
import { apiRequest } from './api';

export const productService = {
  // Get all products with optional filtering and sorting (filtering happens on the server)
  async getProducts(filterParams = {}) {
    return apiRequest('/products', { params: filterParams });
  },

  // Get a single product by slug
  async getProductBySlug(slug) {
    return apiRequest(`/products/${encodeURIComponent(slug)}`);
  },

  // Get related products (same category or shared tags)
  async getRelatedProducts(productId, limit = 4) {
    return apiRequest(`/products/${encodeURIComponent(productId)}/related`, { params: { limit } });
  },

  // Get all categories
  async getCategories() {
    return apiRequest('/categories');
  }
};
